import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  deChatCaseSummaryConfirmationMessageQuery as deChatCaseSummaryConfirmationMessageQueryType,
} from "@/modules/chats/services/ai/de/__generated__/deChatCaseSummaryConfirmationMessageQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query deChatCaseSummaryConfirmationMessageQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    chatCaseSummaryConfirmationMessage: de_chatCaseSummaryConfirmationMessage(aiRequestMetadata: $aiRequestMetadata) {
      text
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const deChatCaseSummaryConfirmationMessageQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<deChatCaseSummaryConfirmationMessageQueryType>(RelayEnvironment, query, {
    aiRequestMetadata,
  }).toPromise()
}
